import React, { FC } from 'react';
import * as MESSAGES from 'constants/messages';
import styled from 'styled-components/macro';
import media from 'styles/media';
import { NewGraduateProfile } from 'proto/v1/apimodel/apimodel';
import {
  Label,
  ProfileField,
  ProfileContent,
  GroupLabel,
  ProfileContentGroup,
  ProfileContentGroupItem,
} from 'components/atoms';

const ClubExperienceContent = styled.div`
  font-size: 16px;
  line-height: 1.5;
  word-wrap: break-word;
  white-space: pre-wrap;

  ${media.mobile} {
    font-size: 14px;
  }
`;

type NewGraduateClubExperiencesFieldProps = {
  clubExperiences: NewGraduateProfile['clubExperiences'] | undefined;
};

const NewGraduateClubExperiencesField: FC<NewGraduateClubExperiencesFieldProps> = props => {
  const { clubExperiences } = props;

  return (
    <div data-testid="new-graduate-club-experience-field">
      <GroupLabel>
        {MESSAGES.PROFILE.FIELD.NEW_GRADUATE_CLUB_EXPERIENCES.LABEL}
      </GroupLabel>
      <ProfileContentGroup>
        {clubExperiences && clubExperiences.length > 0
          ? clubExperiences.map((clubExperience, index) => (
              <ProfileContentGroupItem
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                data-testid="new-graduate-club-experiences-field-item"
              >
                <ProfileField data-testid="new-graduate-club-experience-field-name">
                  <Label>
                    {
                      MESSAGES.PROFILE.FIELD.NEW_GRADUATE_CLUB_EXPERIENCES.NAME
                        .LABEL
                    }
                  </Label>
                  <ProfileContent>{clubExperience.name || '-'}</ProfileContent>
                </ProfileField>
                <ProfileField data-testid="new-graduate-club-experience-field-content">
                  <Label>
                    {
                      MESSAGES.PROFILE.FIELD.NEW_GRADUATE_CLUB_EXPERIENCES
                        .CONTENT.LABEL
                    }
                  </Label>
                  <ClubExperienceContent>
                    {clubExperience.content || '-'}
                  </ClubExperienceContent>
                </ProfileField>
              </ProfileContentGroupItem>
            ))
          : MESSAGES.COMMON.DESCRIPTION.NOT_REGISTERED}
      </ProfileContentGroup>
    </div>
  );
};

export default NewGraduateClubExperiencesField;
